/**
 * Project default config items
 * primaryColor - Default theme color, If color change does not take effect, please clear localStorage
 * navTheme - sidebar theme ['dark', 'light'] Two themes
 * colorWeak - Color blind mode
 * layout - Overall layout method ['sidemenu', 'topmenu'] Two layouts
 * fixedHeader - Fixed Header : boolean
 * fixSiderbar - Fix left sidebar menu : boolean
 * autoHideHeader - Hide when scrolling down Header : boolean
 * contentWidth - Content area layout: Fluid |  Fixed
 *
 * storageOptions: {} - Vue-ls Plugin config items (localStorage/sessionStorage)
 *
 */

export default {
  primaryColor: '#0C9254', // primary color of ant design
  navTheme: 'light', // theme for nav menu
  layout: 'sidemenu', // nav menu position: sidemenu or topmenu
  contentWidth: 'Fixed', // layout of content: Fluid or Fixed, only works when layout is topmenu
  fixedHeader: false, // sticky header
  fixSiderbar: false, // sticky siderbar
  autoHideHeader: false, //  auto hide header
  colorWeak: false,
  multiTab: true,
  production: process.env.NODE_ENV === 'production' && process.env.VUE_APP_PREVIEW !== 'true',
  // vue-ls options
  storageOptions: {
    namespace: 'pro__',
    name: 'ls',
    storage: 'local',
  }
}
